import React, { useEffect, useState } from 'react';
import type { PageProps } from 'gatsby';
import * as styles from '../Footer.module.css';
import FooterLogoSection from './FooterLogoSection';
import FooterSocialSection from './FooterSocialSection';
import FooterNavigationSection from './FooterNavigationSection';

import FooterCfgLogoSection from './FooterCfgLogoSection';

interface FooterProps {
  location: PageProps['location'];
}

const Footer: React.FC<FooterProps> = ({ location }) => {
  const [hasStickyFooter, setHasStickyFooter] = useState(false);

  useEffect(() => {
    const stickyFooterElement = document.getElementById('sticky-footer');
    setHasStickyFooter(!!stickyFooterElement);
  }, [location.pathname, location.search]);

  // Sticky Footerがある場合、フッターの下に余白を追加
  const footerStyle = hasStickyFooter ? { marginBottom: '100px' } : {};

  return (
    <footer className={styles.footer} role='contentinfo' style={footerStyle}>
      <div className={styles.container}>
        <FooterLogoSection />
        <FooterSocialSection />
        <FooterNavigationSection />
        <FooterCfgLogoSection />
      </div>
    </footer>
  );
};

export default Footer;
